import React, {useState, useEffect} from 'react';
import moment from 'moment';

export function DigitoVerificador(T)
{  
      var M=0,S=1;
	  for(;T;T=Math.floor(T/10))
      S=(S+T%10*(9-M++%6))%11;
	  return S?S-1:'K';
 }

 export function separadorMiles(numero) {
      return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
 }

 export function formateaRut(rut, force = false) {
     rut = rut || "";
     rut = rut.toString();
     var actual = rut.replace(/^0+/, "");
     var rutPuntos = "";
     if (actual != '' && actual.length > 1) {
       var sinPuntos = actual.replace(/\./g, "");
       var actualLimpio = sinPuntos.replace(/-/g, "");
       var inicio = actualLimpio.substring(0, actualLimpio.length - 1);
       var i = 0;
       var j = 1;
       for (i = inicio.length - 1; i >= 0; i--) {
         var letra = inicio.charAt(i);
         rutPuntos = letra + rutPuntos;
         if (j % 3 == 0 && j <= inicio.length - 1) {
           rutPuntos = "." + rutPuntos;
         }
         j++;
       }
       var dv = actualLimpio.substring(actualLimpio.length - 1);
       if(force || DigitoVerificador(rutPuntos.replace(/\./g,''))==dv){
        rutPuntos = rutPuntos + "-" + dv;
       }else{
         rutPuntos="";
       }
     }else{
      rutPuntos = actual;
     }
     return rutPuntos;
   }


export function useFormInput(initialValue, label, props) {
    const [value, setValue] = useState(initialValue);

    function handleChange(e) {
        setValue(e.target.value)
    }

    return {
        label,
        fullWidth: true,
        value,
        onChange: handleChange,
        ...(props||{})
    };
}

export function useDateInput(initialValue, label) {
    const [value, setValue] = useState(initialValue);

    function handleChange(e) {
        setValue(e.target.value)
    }

    return {
        label,
        fullWidth: true,
        type: "date",
        defaultValue: initialValue,
        value,
        onChange: handleChange,
        InputLabelProps: {
            shrink: true,
        }

    };
}

export function Duracion(props){
    const [date, setDate] = useState(moment());
    const [dateD, setDateD] = useState(moment());
  
    useEffect(()=>{
      var timerID;
      if(!props.hasta){
        timerID = setInterval(
            () => setDate(moment()),
            1000
        );
      }
      return ()=>{
        if(timerID){
            clearInterval(timerID);
        }
      }
    }
    ,[props])
  
      return (
        <span>{Math.abs((props.hasta?moment(props.hasta):date).diff(props.hasta?props.desde:moment(props.desde)>dateD?dateD:props.desde,'seconds'))}s</span>
      );
  }